import PictureImage from '../Common/PictureImage';
import {
  CONTACT_US_IMAGE,
  CONTACT_US_IMAGE_HEIGHT,
  CONTACT_US_IMAGE_WIDTH,
} from '../../data/optimizedHomepageAssets';
import './ContactUs.css';
import ContactForm from '../Common/ContactForm';

const ContactUs = () => {
  return (
    <section className="contactus-section" style={{ background: '#f9f9fa', padding: '60px 20px', fontFamily: 'sans-serif' }}>
      <div className="contactus-container" style={{ maxWidth: '1280px', margin: '0 auto', display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
        
        {/* Left Side - Image and Tagline */}
        <div className="contactus-image-col" style={{ flex: '1 1 400px' }}>
          <div className="contactus-image-wrapper" style={{ borderRadius: '16px', overflow: 'hidden', marginBottom: '20px' }}>
            <PictureImage
              src={CONTACT_US_IMAGE}
              alt="Contact Pick Pack Pro - UK fulfilment quote and 3PL support"
              className="contactus-image"
              width={CONTACT_US_IMAGE_WIDTH}
              height={CONTACT_US_IMAGE_HEIGHT}
              loading="lazy"
              decoding="async"
              style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }}
            />
          </div>
          <div className="contactus-tagline" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
            <span style={{ width: '32px', height: '3px', background: '#F68C43', marginTop: '10px', display: 'inline-block', flexShrink: 0 }}></span>
            <div>
              <h4 style={{ margin: '0 0 8px 0', fontSize: '1.25rem', fontWeight: 700, color: '#111827' }}>
                A fulfilment partner you can <span style={{ color: '#F68C43' }}>rely on.</span>
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: 1.5 }}>
                Trusted by growing brands across the UK for accurate, fast and scalable fulfilment.
              </p>
            </div>
          </div>

          <div className="contactus-features" style={{ display: 'flex', flexWrap: 'wrap', gap: '28px', marginTop: '28px', borderTop: '1px solid #e2e8f0', paddingTop: '24px', justifyContent: 'flex-start' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <div>
                <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0F172A' }}>24 Hour</div>
                <div style={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600, letterSpacing: '0.5px' }}>RESPONSE TIME</div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
              <div>
                <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0F172A' }}>No Obligation</div>
                <div style={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600, letterSpacing: '0.5px' }}>QUOTES</div>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path></svg>
              <div>
                <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#0F172A' }}>Expert Support</div>
                <div style={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600, letterSpacing: '0.5px' }}>AT EVERY STEP</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form & Header */}
        <div className="contactus-form-col" style={{ flex: '1.2 1 500px' }}>
          
          <div className="contactus-eyebrow" style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#64748b', marginBottom: '16px' }}>
            <span style={{ width: '24px', height: '2px', background: '#F68C43', display: 'inline-block' }}></span>
            GET A QUOTE
          </div>
          
          <h2 style={{ fontSize: '44px', fontWeight: 800, color: '#0F172A', margin: '0 0 16px 0', lineHeight: 1.15 }}>
            Contact Pick Pack Pro:<br/>
            <span style={{ color: '#1A44E5' }}>Get Your Fulfilment Quote</span>
          </h2>
          
          <p style={{ fontSize: '1rem', color: '#475569', lineHeight: 1.6, marginBottom: '32px', maxWidth: '600px' }}>
            Looking for a trusted UK fulfilment partner for Amazon, Shopify, or TikTok Shop? Fill out the form below and receive a customized quote within 24 hours.
          </p>
          
          <div className="contactus-form-wrapper">
            <ContactForm source="homepage-contact" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactUs;


